import ChatPanel from '../../common/utils/ChatPanel';

export default class ExtranetStudyRequestsShow {

  constructor() {
      this.bindEvents();
      this.chatPanel = new ChatPanel();
  }


  bindEvents() {
  }

  onDataChanged(data) {
  }

  onDestroy() {
    if (this.chatPanel && typeof this.chatPanel.onDestroy === 'function') {
      this.chatPanel.onDestroy();
    }
  }
}